'use strict';

// The property in the cloud-storage-config-service config record is called "storageType"
var cloudStorageConfigTypes = {
    AWS: 'AWS',
    AZURE: 'AZURE',
    GCS: 'GCS',
    S3_COMPATIBLE: 'S3_COMPATIBLE',
    AWS_AUTHENTICATION: 'AWS_AUTHENTICATION',
    GCP_CLOUD_STORAGE_AUTHENTICATION: 'GCP_CLOUD_STORAGE_AUTHENTICATION',
    WASABI_CLOUD_STORAGE_AUTHENTICATION: 'WASABI_CLOUD_STORAGE_AUTHENTICATION',
    AZURE_STORAGE_ACCESS_KEY_AUTHENTICATION: 'AZURE_STORAGE_ACCESS_KEY_AUTHENTICATION'
};

module.exports = cloudStorageConfigTypes;